const nullLocation = {
  area_id: null,
  latitude: 0,
  longitude: 0,
  province: "云南省",
  city: "昆明市",
  county: "盘龙区",
  areastext: "云南省 昆明市 盘龙区",
  address: "",
}
const location = {
  state: {
    location: nullLocation,
  },
  mutations: {
    SET_LOCATION(state, location) {
      Object.assign(state.location, location || nullLocation)
    },
  },
}

export default location
